export default "__VITE_ASSET__D54lxEnA__"